export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./banner-native.vue?vue&type=template&id=9fff797a&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/banner-native/banner-native.vue?vue&type=template&id=9fff797a&
// module id = 1070
// module chunks = 0